<header fxLayout="row" fxFlex="100%" fxLayoutAlign="start">
    <img fxFlex="40%"src="../../../assets/images/check-circle.svg">
    <div fxFlex fxLayoutAlign="center">
      <strong >
       {{Message}}
     </strong>
  </div>
</header>